import { GET_CARTS } from "constants/carts";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_CARTS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
